const scope = 'ADVNEW/filters';
import {get as _get} from "lodash";
import FilterCategories from "Constants/advocates/FilterCategories";
import FilterConfig from "Constants/advocates/FilterConfig";
import SegmentsConstants from "Constants/advocates/Segments";
import FrequencyTypes from "Constants/advocates/FrequencyTypes";
import { SET_APPLIED_FILTERS } from '../../../../constants/advocates/store/filter/actions'

const mod = {
    namespaced: true,
    state: {
        currentUserId: null,
        currentUserEmail: null,
        currentCustomerId: null,
        currentCustomersIds: null,
        displayFilterDropdown: false,
        appliedFilterCategories: [],
        appliedFilterRows: [],
        filterCategories: FilterCategories,
        filterConfig: FilterConfig,
        enabledFilters: [],
        enabledColumnSort: {
            column: 'name',
            order: 'DESC'
        },
        locationSearch: " ",
        locationSearchMessage: "Searching...",
        customerTags: [],
        customerStages: [],
        customerCampaigns: [],
        customerSources: [],
        states: [],
        legislativeDistricts: [],
        committees: [],
        customerEmails: [],
        hasEmailerAccess: false,
        hasSegmentsExportAccess: false,
        hasAdvocateStageAccess: false,
        dropdownOpen: false,
        dropdownUpdateInProgress: false,
        campaignActivityOfficials: [],
        officialsSearchQuery: " ",
        advocatePrefixes: [],
        successfulExport: false,
        duplicateExport: false,
        advocateSearchResults: [],
        advocateSearchIsLoading: false,
        advocateSearchParameter: "",
        advocateSearchHitCount: null,
        groupSearchActive: false,
        groupSearchParameter: null,
        groupSearchResults: [],
        successfulTaggingQueue: false,
        finishedTaggingQueue: false,
        errorTaggingQueue: false,
        bannerVisibility: {
            taggingNotAllowed: false,
            deleteNotAllowed: false,
        },
        selectorSearchMessage: null,
        tagsSearchQuery: "",
        tagsSearchAsync: false,
        tagsAreLoading: false,
        userPrivateSegments: [],
        userGlobalSegments: [],
        appliedSegmentFilter: [],
        showSaveAsSegmentButton: false,
        segmentEditMode: SegmentsConstants.DEFAULT_SEGMENT_EDIT_MODE,
        currentlySelectedSegment: null,
        lastCreatedSegment: {},
        selectedSegmentSchedule: {},
        scheduleExportUsers: [],
        scheduleExportSelectedUsers: [],
        scheduleExportSelectedFrequencyType: FrequencyTypes.DEFAULT_SCHEDULE_TYPE,
        scheduleExportSelectedFrequencyDay: FrequencyTypes.DEFAULT_WEEKLY_DAY,
        hasDisplayMxOn: true,
        defaultColumns: [],
        appliedExportColumns: { defaultColumns: [], tags: [], campaigns: [], customFields: [] },
        isExportV2Enabled: false,
        isAdvocateImportEnabled: false,
        isMatchByAdvocateIdEnabled: false,
        isSendConnectionsEnabled: false,
        requireSmsDoubleOptIn: false,
        isFullNameEnabled: false,
        isGlobalImportTagEnabled: false,
        isP2AEmployee: false,
    },
    mutations: {
        setCurrentUserId(state, payload) {
            state.currentUserId = payload;
        },
        setCurrentUserEmail(state, payload) {
            state.currentUserEmail = payload;
        },
        setCurrentCustomerId(state, payload) {
            state.currentCustomerId = payload;
        },
        setCurrentCustomersIds(state, payload) {
            state.currentCustomersIds = payload;
        },
        toggleFilterDropdown(state, payload){
          state.displayFilterDropdown = !state.displayFilterDropdown;
        },
        closeFilterDropdown(state, payload){
            if(state.dropdownOpen === false){
                state.displayFilterDropdown = false;
            }
            state.dropdownUpdateInProgress = false;
        },
        applyFilterCategory(state, filter) {
            state.appliedFilterCategories.push(filter);
        },
        applyFilterRow(state, row) {
            state.appliedFilterRows.push(row);
        },
        setAppliedFilters(state, filters) {
            const existingCategories = [];
            state.appliedFilterCategories = [];
            state.appliedFilterRows = [];
            filters.forEach(filterRow => {
                const filterCategory = state.filterCategories.find(category => filterRow.category === category.name);
                // If we haven't added this filter category, add it to the list.
                if (existingCategories.indexOf(filterRow.category) === -1) {
                    state.appliedFilterCategories.push(filterCategory);
                    existingCategories.push(filterRow.category);
                }
                state.appliedFilterRows.push(filterRow);
            });
        },
        setAppliedColumns(state, columns) {
            state.appliedExportColumns = columns;
        },
        setDefaultColumns(state, columns) {
            state.defaultColumns = columns;
        },
        selectRowOption(state, payload) {
            state.appliedFilterRows.filter(appliedFilterRow => appliedFilterRow.category == payload.category)[payload.rowIndex][payload.type] = payload.option;
        },
        toggleLastRowHighlight(state) {
            state.appliedFilterRows[state.appliedFilterRows.length - 1].highlighted = false;
        },
        enableAppliedFilters(state) {
            let enabledFilterRows = [];
            let exclusiveFilterRows = [];
            state.appliedFilterRows.forEach(row => {
                if (_get(row, 'selector.name', null) === "Any location") {
                    row.data = {name: "Any location"};
                }
                if (_get(row, 'selector.name', null) === "is_not_tagged") {
                    exclusiveFilterRows.push(row);
                } else if (row.data) {
                    row.data.name === "any tag" ? enabledFilterRows.unshift(row) : enabledFilterRows.push(row);
                } else {
                    enabledFilterRows.push(row);
                }
            })
            state.enabledFilters = enabledFilterRows.concat(exclusiveFilterRows);
            if(state.appliedFilterRows[0].category === 'campaign_activity'){
                state.enabledFilters = state.enabledFilters.reverse();
            }
        },
        removeAppliedFilterRow(state, payload) {
            state.appliedFilterRows.splice(payload.rowIndex, 1);
            state.appliedFilterRows.forEach(row => {
                if (row.globalRowIndex > payload.rowIndex && row.globalRowIndex > 0) {
                    row.globalRowIndex -= 1;
                }
            })
            // if the total rows for a category is 0, remove the category altogether.
            if (state.appliedFilterRows.filter(appliedFilterRow => appliedFilterRow.category == payload.category).length < 1) {
                const newCategories = [];
                state.appliedFilterCategories.forEach(category => {
                    if (category.name != payload.category) {
                        newCategories.push(category)
                    }
                })
                state.appliedFilterCategories = newCategories;
            }
        },
        clearEnabledFilters(state, payload) {
            state.appliedFilterCategories = [];
            state.appliedFilterRows = [];
            state.enabledFilters = [];
        },
        clearAppliedSegment(state) {
            state.appliedSegmentFilter = [];
        },
        updateAllRows(state, payload) {
            // if we are updating all rows, all conjunctions need to be updated regardless of filter category.
            if (payload.type === "conjunction") {
                state.appliedFilterRows.forEach(row => {
                    row[payload.type] = payload.option;
                })
            }
            // otherwise, only update the rows that belong to that filter category.
            else {
                state.appliedFilterRows.forEach(row => {
                    if (row.category === payload.category && row.category === "campaign_activity") {
                        row[payload.type] = payload.option;
                    }
                })
            }
        },
        updateLocationSearch(state, payload) {
            state.locationSearch = payload.locationSearch;
        },
        updateLocationSearchMessage(state, payload) {
            state.locationSearchMessage = payload.message;
        },
        updateSelectorSearchMessage(state, payload) {
            state.selectorSearchMessage = payload.message;
        },
        enableColumnSort(state, payload){
            state.enabledColumnSort.column = payload.column;
            state.enabledColumnSort.order = payload.order;
        },
        setCustomerTags(state, payload){
          state.customerTags = payload.tags;
        },
        setCustomerStages(state, payload){
            state.customerStages = payload.stages;
        },
        setCustomerCampaigns(state, payload){
          state.customerCampaigns = payload.campaigns;
        },
        setCustomerSources(state, payload){
            state.customerSources = payload.sources;
        },
        setStates(state, payload){
            state.states = payload.states;
        },
        setLegislativeDistricts(state, payload){
            state.legislativeDistricts = payload.legislativeDistricts;
        },
        setCommittees(state, payload){
            state.committees = payload.committees;
        },
        setFilterCategories(state, payload){
          state.filterCategories = payload.categories;
        },
        setEmailerAccess(state, payload){
            state.hasEmailerAccess = payload.emailerAccess;
        },
        setSegmentsExportAccess(state, payload){
            state.hasSegmentsExportAccess = payload.segmentsExportAccess;
        },
        setAdvocateStageAccess(state, payload){
            state.hasAdvocateStageAccess = payload.stageAccess;
        },
        setCustomerEmails(state, payload){
            state.customerEmails = payload.emails;
        },
        setDropdownOpen(state, payload){
            state.dropdownOpen = payload.open;
        },
        trackDropdownUpdateInProgress(state, payload){
            state.dropdownUpdateInProgress = true;
        },
        setCampaignActivityOfficials(state, payload) {
            state.filterCategories.find(filter => filter.name === "campaign_activity").row.data_settings.extended_selection_prefix_options = payload.officials;
        },
        setOfficialsSearchQuery(state, payload) {
            state.officialsSearchQuery = payload;
        },
        setAdvocatePrefixes(state, payload){
            state.advocatePrefixes = payload;
        },
        setSuccessfulExport(state, payload){
            state.successfulExport = payload.successfulExport;
        },
        setDuplicateExport(state, payload){
            state.duplicateExport = payload.duplicateExport;
        },
        updateAdvocateSearchResults(state, payload){
            state.advocateSearchResults = payload.results;
        },
        updateAdvocateSearchIsLoading(state, payload){
            state.advocateSearchIsLoading = payload.loading;
        },
        updateAdvocateSearchParameter(state, payload){
            state.advocateSearchParameter = payload.parameter;
        },
        updateGroupSearchActive(state, payload){
            state.groupSearchActive = payload.active;
        },
        updateGroupSearchParameter(state, payload){
            state.groupSearchParameter = payload.parameter;
        },
        updateGroupSearchResults(state, payload){
            state.groupSearchResults = payload.results;
        },
        updateAdvocateSearchHitCount(state, payload){
            state.advocateSearchHitCount = payload.totalHits;
        },
        setSuccessfulTaggingQueue(state, payload){
            state.successfulTaggingQueue = payload;
        },
        setFinishedTaggingQueue(state, payload){
            state.finishedTaggingQueue = payload;
        },
        setErrorTaggingQueue(state, payload){
            state.errorTaggingQueue = payload;
        },
        setBannerVisibility(state, payload) {
            state.bannerVisibility[payload[0]] = payload[1];
        },
        setTagsSearchQuery(state, payload) {
            state.tagsSearchQuery = payload;
        },
        setTagsSearchAsync(state, payload) {
            state.tagsSearchAsync = payload;
        },
        setTagsAreLoading(state, payload) {
            state.tagsAreLoading = payload;
        },
        setUserPrivateSegments(state, payload){
            state.userPrivateSegments = payload.segments;
        },
        setUserGlobalSegments(state, payload){
            state.userGlobalSegments = payload.segments;
        },
        setAppliedSegmentFilter(state, payload) {
            state.appliedSegmentFilter = payload.segmentData;
        },
        setShowSaveAsSegmentButton(state, payload) {
            state.showSaveAsSegmentButton = payload;
        },
        setSegmentEditMode(state, payload) {
            state.segmentEditMode = payload;
        },
        setCurrentlySelectedSegment(state, payload) {
            state.currentlySelectedSegment = payload;
        },
        setLastCreatedSegment(state, payload) {
            state.lastCreatedSegment = payload;
        },
        setSelectedSegmentSchedule(state, payload) {
            state.selectedSegmentSchedule = payload;
        },
        setScheduleExportUsers(state, payload) {
            state.scheduleExportUsers = payload;
        },
        setScheduleExportSelectedUsers(state, payload) {
            state.scheduleExportSelectedUsers = payload;
        },
        setScheduleExportSelectedFrequencyType(state, payload) {
            state.scheduleExportSelectedFrequencyType = payload;
        },
        setScheduleExportSelectedFrequencyDay(state, payload) {
            state.scheduleExportSelectedFrequencyDay = payload;
        },
        setDisplayMx(state, payload) {
            state.hasDisplayMxOn = payload;
        },
        setIsExportV2Enabled(state, payload) {
            state.isExportV2Enabled = payload;
        },
        setIsAdvocateImportEnabled(state, payload) {
            state.isAdvocateImportEnabled = payload;
        },
        setIsMatchByAdvocateIdEnabled(state, payload) {
            state.isMatchByAdvocateIdEnabled = payload;
        },
        setIsSendConnectionsEnabled(state, payload) {
            state.isSendConnectionsEnabled = payload;
        },
        setRequireSmsDoubleOptIn(state, payload) {
            state.requireSmsDoubleOptIn = payload;
        },
        setIsFullNameEnabled(state, payload) {
            state.isFullNameEnabled = payload;
        },
        setIsCustomFieldsEnabled(state, payload) {
            state.isCustomFieldsEnabled = payload;
        },
        setIsFBLeadAdEnabled(state, payload) {
            state.isFBLeadAdEnabled = payload;
        },
        setIsGlobalImportTagEnabled(state, payload) {
            state.isGlobalImportTagEnabled = payload;
        },
        setIsP2AEmployee(state, payload) {
            state.isP2AEmployee = payload;
        },
    },
    actions: {
      [SET_APPLIED_FILTERS]({ commit }, filters) {
        commit('setAppliedFilters', filters);
      },
    },
    getters: {
        currentUserId(state) {
            return state.currentUserId;
        },
        currentUserEmail(state) {
            return state.currentUserEmail;
        },
        currentCustomerId(state) {
            return state.currentCustomerId;
        },
        currentCustomersIds(state) {
            return state.currentCustomersIds;
        },
        displayFilterDropdown(state) {
          return state.displayFilterDropdown;
        },
        appliedFilterCategories(state) {
            return state.appliedFilterCategories;
        },
        appliedFilterRows(state) {
            return state.appliedFilterRows;
        },
        appliedExportColumns(state) {
            return state.appliedExportColumns;
        },
        defaultColumns(state) {
            return state.defaultColumns;
        },
        enabledFilters(state) {
            return state.enabledFilters;
        },
        locationSearch(state) {
            return state.locationSearch;
        },
        locationSearchMessage(state) {
            return state.locationSearchMessage;
        },
        selectorSearchMessage(state) {
            return state.selectorSearchMessage;
        },
        enabledColumnSort(state) {
            return state.enabledColumnSort;
        },
        customerTags(state){
          return state.customerTags;
        },
        customerStages(state){
            return state.customerStages;
        },
        customerCampaigns(state){
          return state.customerCampaigns;
        },
        filterCategories(state){
          state.filterCategories.filter(filter => filter.name === "tags")[0].row.data = [{ name: "any tag" }, ...state.customerTags];
          state.filterCategories.filter(filter => filter.name === "stages")[0].row.data = [{ name: "any stage" }, ...state.customerStages];
          state.filterCategories.filter(filter => filter.name === "campaign_activity")[0].row.data = [{ name: "any campaign" }, ...state.customerCampaigns];
          state.filterCategories.filter(filter => filter.name === "email_activity")[0].row.data = [{ name: "any email" }, ...state.customerEmails];
            state.filterCategories.filter(filter => filter.name === "sources")[0].row.data = [{ name: "any source" }, ...state.customerSources];
          return state.filterCategories;
        },
        filterConfig(state) {
          return state.filterConfig;
        },
        hasEmailerAccess(state){
            return state.hasEmailerAccess;
        },
        hasSegmentsExportAccess(state){
            return state.hasSegmentsExportAccess;
        },
        hasAdvocateStageAccess(state){
            return state.hasAdvocateStageAccess;
        },
        customerEmails(state){
            return state.customerEmails;
        },
        customerSources(state){
            return state.customerSources;
        },
        states(state){
            return state.states;
        },
        legislativeDistricts(state){
            return state.legislativeDistricts;
        },
        committees(state){
            return state.committees;
        },
        dropdownOpen(state){
            return state.dropdownOpen;
        },
        dropdownUpdateInProgress(state){
            return state.dropdownUpdateInProgress;
        },
        officialsSearchQuery(state) {
            return state.officialsSearchQuery;
        },
        advocatePrefixes(state){
            return state.advocatePrefixes;
        },
        appliedCategories(state) {
          if (state.appliedFilterRows.length === 0) {
            return [];
          }
          return state.appliedFilterRows.map(row => row.category);
        },
        firstAppliedFilter(state) {
          if (state.appliedFilterRows.length === 0) {
            return null;
          }
          return state.appliedFilterRows[0].category;
        },
        successfulExport(state){
            return state.successfulExport;
        },
        duplicateExport(state){
            return state.duplicateExport;
        },
        advocateSearchResults(state){
            return state.advocateSearchResults;
        },
        advocateSearchIsLoading(state){
            return state.advocateSearchIsLoading;
        },
        advocateSearchParameter(state){
            return state.advocateSearchParameter;
        },
        advocateSearchHitCount(state){
            return state.advocateSearchHitCount;
        },
        groupSearchActive(state){
            return state.groupSearchActive;
        },
        groupSearchParameter(state){
            return state.groupSearchParameter;
        },
        groupSearchResults(state){
            return state.groupSearchResults;
        },
        successfulTaggingQueue(state){
            return state.successfulTaggingQueue;
        },
        finishedTaggingQueue(state){
            return state.finishedTaggingQueue;
        },
        errorTaggingQueue(state){
            return state.errorTaggingQueue;
        },
        bannerVisibility(state) {
            return state.bannerVisibility;
        },
        tagsSearchQuery(state) {
            return state.tagsSearchQuery;
        },
        tagsSearchAsync(state) {
            return state.tagsSearchAsync;
        },
        tagsAreLoading(state) {
            return state.tagsAreLoading;
        },
        userPrivateSegments(state){
            return state.userPrivateSegments;
        },
        userGlobalSegments(state){
            return state.userGlobalSegments;
        },
        appliedSegmentFilter(state) {
            return state.appliedSegmentFilter;
        },
        showSaveAsSegmentButton(state) {
            return state.showSaveAsSegmentButton;
        },
        segmentEditMode(state) {
            return state.segmentEditMode;
        },
        currentlySelectedSegment(state) {
            return state.currentlySelectedSegment;
        },
        lastCreatedSegment(state) {
            return state.lastCreatedSegment;
        },
        selectedSegmentSchedule(state) {
            return state.selectedSegmentSchedule;
        },
        scheduleExportUsers(state) {
            return state.scheduleExportUsers;
        },
        scheduleExportSelectedUsers(state) {
            return state.scheduleExportSelectedUsers;
        },
        scheduleExportSelectedFrequencyType(state) {
            return state.scheduleExportSelectedFrequencyType;
        },
        scheduleExportSelectedFrequencyDay(state) {
            return state.scheduleExportSelectedFrequencyDay;
        },
        hasDisplayMxOn(state) {
            return state.hasDisplayMxOn;
        },
        isExportV2Enabled(state) {
            return state.isExportV2Enabled;
        },
        isAdvocateImportEnabled(state) {
            return state.isAdvocateImportEnabled;
        },
        isMatchByAdvocateIdEnabled(state) {
            return state.isMatchByAdvocateIdEnabled;
        },
        isSendConnectionsEnabled(state) {
            return state.isSendConnectionsEnabled;
        },
        isFullNameEnabled(state) {
            return state.isFullNameEnabled;
        },
        isCustomFieldsEnabled(state) {
            return state.isCustomFieldsEnabled;
        },
        isFBLeadAdEnabled(state) {
            return state.isFBLeadAdEnabled;
        },
        requireSmsDoubleOptIn(state) {
            return state.requireSmsDoubleOptIn;
        },
        isGlobalImportTagEnabled(state) {
            return state.isGlobalImportTagEnabled;
        },
        isP2AEmployee(state) {
            return state.isP2AEmployee;
        },
    },
};

export default mod;
